import React from 'react'

type VideoProps = {
  srcMp4: string
  srcWebm: string
  onEnded: any
}

const Video = React.forwardRef<HTMLVideoElement, VideoProps>(
  ({ srcMp4, srcWebm, onEnded }, ref) => {
    return (
      <video
        ref={ref}
        muted
        preload='auto'
        onEnded={onEnded}
        playsInline
        controls={false}
        style={{
          visibility: 'hidden',
          gridColumnStart: 1,
          gridRowStart: 1,
          gridColumnEnd: 2,
          gridRowEnd: 2,
          maxWidth: 'none',
          alignSelf: 'flex-start',
          justifySelf: 'center',
          objectFit: 'cover'
        }}
      >
        <source src={srcMp4} type='video/mp4; codecs="hvc1"' />
        <source src={srcWebm} type='video/webm' />
      </video>
    )
  }
)

export default Video
